import React, { Component } from "react";
import { Grid, Header, Button, Segment, Radio, Transition } from 'semantic-ui-react';

class Step2 extends Component {

  constructor(props)
  {
    super(props);
    this.state = { checked: false, visible: false, animation: props.animation,schedule: {},
    }

    this.schedule = {
      1: {id: 1},
      2: {id: 2},
      3: {id: 3},
      4: {id: 4},
      5: {id: 5},
      6: {id: 6},
    }

    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
    this.changeSchedule = this.changeSchedule.bind(this);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
  }

  transitionBack(){
  const {  changeStep } = this.props;

    this.setState({
      animation: "fade left",
      visible: false
    });
    setTimeout(() => {
      changeStep(1, "fade right")
    }, 400);
  }

 transitionNext()
 {
  const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(3, "fade left")
    }, 400);
 }

 toggle = () => {

  this.setState({
    checked: !this.state.checked
  })
}

 changeSchedule(e, {value}) {
  this.setState({ schedule: this.schedule[value]});
 }

  render() {
    const { changeStep } = this.props;
    const { visible, animation } = this.state;

    return <div>
      <div className="back--icon" onClick={this.transitionBack }></div>
      <Transition visible={visible} duration={500} animation={animation}>
        <div>
          <Header className='title__main' as='h1' textAlign='center'>Schedule Installation
          </Header>
          <Header.Subheader className='text-black'>Choose a time below for a technician to install service in your unit.</Header.Subheader>

          <Grid className='form__signup schedule-installation width__xs'>
            <Grid.Row className="py-0">
              <Grid.Column className="px-0">
                <Segment className="bg--grey">
                  <Segment basic inverted={this.state.schedule.id === 1}>
                    <Radio label={<label><span className='itc-mdbold'>Wed, Mar 14</span><span className='time'>1PM – 2PM</span></label>} value={1} checked={this.state.schedule.id === 1} onChange={this.changeSchedule} />
                  </Segment>

                  <Segment basic inverted={this.state.schedule.id === 2}>
                    <Radio label={<label><span className='itc-mdbold'>Wed, Mar 14</span><span className='time'>2PM – 3PM</span></label>} value={2} checked={this.state.schedule.id === 2} onChange={this.changeSchedule} />
                  </Segment>

                  <Segment basic inverted={this.state.schedule.id === 3}>
                    <Radio label={<label><span className='itc-mdbold'>Wed, Mar 14</span><span className='time'>3PM – 4PM</span></label>} value={3} checked={this.state.schedule.id === 3} onChange={this.changeSchedule} />
                  </Segment>

                  <Segment basic inverted={this.state.schedule.id === 4}>
                    <Radio label={<label><span className='itc-mdbold'>Thu, Mar 15</span><span className='time'>10PM – 11PM</span></label>} value={4} checked={this.state.schedule.id === 4} onChange={this.changeSchedule} />
                  </Segment>

                  <Segment basic inverted={this.state.schedule.id === 5}>
                    <Radio label={<label><span className='itc-mdbold'>Thu, Mar 15</span><span className='time'>11AM – 12PM</span></label>} value={5} checked={this.state.schedule.id === 5} onChange={this.changeSchedule} />
                  </Segment>

                  <Segment basic inverted={this.state.schedule.id === 6}>
                    <Radio label={<label><span className='itc-mdbold'>Thur, Mar 15</span><span className='time'>11AM – 12AM</span></label>} value={6} checked={this.state.schedule.id === 6} onChange={this.changeSchedule} />
                  </Segment>
                </Segment>

                <Button className='btn--full' type="button" size='medium' onClick={this.transitionNext }>Next</Button>
                <Button className='btn--full btn--light-blue' type="button" size='medium' onClick={() => changeStep(3)}>These times don't work for me</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Transition>
    </div>
  };
}

export default Step2;


// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/Step2.js